module.exports = __webpack_public_path__ + "static/media/linkedin-logo.f16692fc.svg";